import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  'hipobuy-article-1': 'https://readdy.ai/api/search-image?query=Organized%20minimal%20desk%20setup%20with%20notebook%20and%20color%20swatches%20in%20neutral%20earth%20tones%2C%20morning%20sunlight%20casting%20gentle%20shadows%2C%20architectural%20interior%20with%20textured%20walls%2C%20editorial%20minimal%20photography%2C%20soft%20beige%20and%20terracotta%20palette&width=800&height=600&seq=guide-desk-v3&orientation=landscape',
  'hipobuy-article-2': 'https://readdy.ai/api/search-image?query=Two%20pairs%20of%20designer%20footwear%20displayed%20elegantly%20on%20a%20minimal%20white%20pedestal%2C%20natural%20daylight%20from%20large%20window%2C%20gallery%20setting%20with%20clean%20lines%2C%20modern%20minimalist%20product%20photography%2C%20soft%20diffused%20lighting%2C%20warm%20neutral%20background&width=800&height=600&seq=review-pair-v3&orientation=landscape',
  'hipobuy-article-3': 'https://readdy.ai/api/search-image?query=Stack%20of%20neatly%20folded%20organic%20cotton%20garments%20in%20muted%20earth%20tones%20on%20a%20light%20oak%20shelf%2C%20minimal%20retail%20display%20aesthetic%2C%20soft%20ambient%20lighting%2C%20clean%20background%2C%20premium%20textile%20textures%20visible%2C%20Scandinavian%20design%20sensibility&width=800&height=600&seq=compare-stack-v3&orientation=landscape',
  'hipobuy-article-4': 'https://readdy.ai/api/search-image?query=Modern%20security%20concept%20with%20minimal%20design%20elements%2C%20soft%20gradient%20background%20in%20sage%20green%20and%20cream%2C%20abstract%20protective%20shapes%2C%20clean%20geometric%20composition%2C%20calming%20professional%20aesthetic%2C%20no%20text%2C%20editorial%20quality&width=800&height=600&seq=safety-padlock-v3&orientation=landscape',
  'hipobuy-article-5': 'https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20with%20an%20open%20blank%20journal%20and%20a%20single%20green%20plant%2C%20warm%20morning%20light%2C%20cream%20walls%2C%20minimal%20desk%20setup%2C%20peaceful%20and%20inviting%20atmosphere%2C%20lifestyle%20photography%2C%20soft%20shadows&width=800&height=600&seq=beginner-steps-v3&orientation=landscape',
  'hipobuy-article-6': 'https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20of%20everyday%20essentials%20including%20a%20notebook%20pen%20and%20small%20decorative%20objects%20on%20a%20smooth%20stone%20surface%2C%20gentle%20sunlight%2C%20minimal%20bohemian%20aesthetic%2C%20neutral%20sand%20and%20cream%20palette%2C%20editorial%20composition&width=800&height=600&seq=tips-flatlay-v3&orientation=landscape',
};

export default function ArticlesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            Latest SEO Guides &amp; Resources
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            Expert-written articles to help you master Hipobuy Spreadsheet, product research, and smart shopping strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-accent-300 transition-all duration-200"
            >
              <div className="aspect-[4/3] overflow-hidden relative">
                <img
                  src={articleImages[article.imageSeq]}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={`Hipobuy Spreadsheet - ${article.title}`}
                />
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] font-semibold px-2 py-1 rounded-full bg-background-50/90 text-foreground-900 whitespace-nowrap">
                    {article.type}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-2 group-hover:text-accent-700 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-400 mb-3 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.readTime}</span>
                  <span>{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/hipobuy-spreadsheet-guide"
            className="inline-flex items-center space-x-2 text-sm text-accent-600 hover:text-accent-700 font-medium transition-colors"
          >
            <span>View All Guides</span>
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}